import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { MapControlTask } from '../../../components/map-control/map-control.component';
import { StreetViewControlOptions } from '@agm/core';

@Component({
  selector: 'tasks-map',
  templateUrl: './tasks-map.component.html',
  styleUrls: ['./tasks-map.component.scss'],
})
export class TasksMapComponent implements OnInit {
  private _tasks: MapControlTask[] = [];
  private _selectedTaskId: number;
  @Input() lazyLoad = false;
  @Input() organisations: any[] = [];
  @Input() customStyle: {} = { height: 'calc(100%)' };
  @Input() zoom = null;
  @Input() mapOptions: {
    streetViewControl?: boolean;
    streetViewControlOptions?: StreetViewControlOptions;
  } = {};

  @Input('tasks')
  set tasks(value: MapControlTask[]) {
    this.setRouteColours(value);
    this._tasks = value;
  }

  @Input('selectedTaskId')
  set selectedTaskId(value: number) {
    this._selectedTaskId = value;
    this.highlightTask(value);
  }

  get tasks() {
    return this._tasks;
  }

  directionColors = ['#0082CB', '#F97316', '#634ECAB2', '#DC3535'];
  highlightedRoute: number;

  public originIcon = {
    url: 'assets/images/icons/svg/pickup-icon.svg',
    scaledSize: { width: 32, height: 32 },
  };

  public destinationIcon = {
    url: 'assets/images/icons/svg/dropoff-icon.svg',
    scaledSize: { width: 32, height: 32 },
  };

  public homeIcon = 'assets/images/icons/svg/home-icon.svg';

  private soloMapTaskId: number;

  ngOnInit(): void {}

  highlightTask(taskId: number) {
    this.soloMapTaskId = taskId;
    this._tasks.forEach((x) => {
      x.map.hidden = this.soloMapTaskId != null && this.soloMapTaskId != x.id;
    });
    this._tasks = [...this._tasks];
  }

  toggleRoute(task: MapControlTask, event) {
    event.stopPropagation();

    this.soloMapTaskId =
      this.soloMapTaskId == null || this.soloMapTaskId != task.id ? task.id : null;

    this._tasks.forEach((x) => {
      x.map.hidden = this.soloMapTaskId != null && this.soloMapTaskId != x.id;
    });

    this._tasks = [...this._tasks];
  }

  setRouteColours(routeTasks: MapControlTask[]) {
    routeTasks.forEach((x, i) => {
      x.map = {
        taskId: x.id,
        hidden: false,
        directions: { opacity: 0.7, color: this.directionColors[i] },
      };
    });
  }
}
